export const updateRewardQuantityFromVariants = (variants) => {
  const rewardQuantityInput = document.getElementById('reward_quantity');
  if (!rewardQuantityInput) return;

  // Calculate sum of all variant quantities
  let totalQuantity = 0;
  let hasValidQuantities = false;

  variants.forEach(variant => {
    if (variant.enabled && variant.quantity && !isNaN(parseInt(variant.quantity, 10))) {
      totalQuantity += parseInt(variant.quantity, 10);
      hasValidQuantities = true;
    }
  });

  if (hasValidQuantities) {
    // Set total and disable input when variants have quantities
    rewardQuantityInput.value = totalQuantity;
    rewardQuantityInput.disabled = true;
  } else {
    // Reset to default and enable input when no variant quantities
    const defaultQuantity = rewardQuantityInput.dataset.persistedQuantity || "";
    rewardQuantityInput.value = defaultQuantity;
    rewardQuantityInput.disabled = false;
  }
};
